declare global {
  interface Window {
    __AYBLE_IS_AUTOMATED_CLIENT__?: boolean;
    CefSharp?: unknown;
  }
}

const BOT_UA_PATTERN =
  /(bot|crawler|spider|crawling|headless|phantomjs|slurp|bingpreview|yandex|baiduspider|duckduckbot|facebookexternalhit|ia_archiver|embedly|quora link preview|slackbot|discordbot|telegrambot|whatsapp|skypeuripreview|pinterest|cefsharp|selenium|puppeteer|playwright|chrome-lighthouse|lighthouse)/i;

export const isLikelyAutomatedClient = (): boolean => {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return false;
  }

  if (typeof window.__AYBLE_IS_AUTOMATED_CLIENT__ === 'boolean') {
    return window.__AYBLE_IS_AUTOMATED_CLIENT__;
  }

  const userAgent = navigator.userAgent || '';
  const isAutomated = Boolean(
    navigator.webdriver ||
      window.CefSharp ||
      BOT_UA_PATTERN.test(userAgent)
  );

  window.__AYBLE_IS_AUTOMATED_CLIENT__ = isAutomated;
  return isAutomated;
};
